"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    anchorButton: {
      '&:hover': {
        color: palette.primary.main
      }
    },
    linkButton: {
      padding: 0,
      color: palette.link.main,
      '&:hover': {
        color: palette.link.dark
      }
    }
  };
});
exports.useStyles = useStyles;